module.exports = __webpack_public_path__ + "static/media/1005663.067f1e07.jpg";